LiveForm.setOptions({
    messageErrorPrefix: '&nbsp;<i class="icon-exclamation-outline" aria-hidden="true"></i>&nbsp;',
    messageErrorClass: 'form-text text-danger',
    messageTag: 'div'
});
